import { render } from "./CreateClientForm.vue?vue&type=template&id=baf305bc"
import script from "./CreateClientForm.vue?vue&type=script&lang=js"
export * from "./CreateClientForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__